import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "./script";

const PortfolioList = [
  {
    image: "",
    category: "UI/UX DESIGN",
    title: "DiGiTAL BASE",
    link: "https://xd.adobe.com/view/63ec3c57-49a9-4eb6-8dc9-64f80a6b6b67-36bf/",
  },
  {
    image: "",
    category: "WEBSITE",
    title: "Brindaban Enterprise",
    link: "https://brindabanenterprise.web.app/",
  },
  {
    image: "image-4",
    category: "WEBSITE",
    title: "Raj Palace Banquet Hall",
    link: "https://rajpalacebanquethall.web.app/",
  },
  {
    image: "image-3",
    category: "WEBSITE",
    title: "Adchem Industries",
    link: "https://adchemindustries-ac749.web.app/",
  },
  {
    image: "image-1",
    category: "WEBSITE",
    title: "Dr. Sumaiya's Health & Beauty Clinic",
    link: "https://drsumaiyaclinic.web.app/",
  },
  {
    image: "",
    category: "WEBSITE",
    title: "S.B. Public School",
    link: "https://sbpschool.co.in/",
  },
];

class Portfolio extends Component {
  render() {
    let title = "Our Stunning Portfolio",
      description =
        "We ensure that every work we do conforms to international best practices.";
    return (
      <React.Fragment>
        <div className="portfolio-wrapper" style={{ background: "#0000" }}>
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="section-title text-center">
                  <h2>{title}</h2>
                  <p className="description">{description}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="portfolio-slick-activation mt--70 mt_sm--40">
            <Slider {...portfolioSlick2}>
              {PortfolioList.map((value, index) => (
                <div className="portfolio" key={index}>
                  <div
                    className="thumbnail-inner"
                    style={{ border: "2px solid #009FFD" }}
                  >
                    {/* <div className={`thumbnail ${value.image}`}></div> */}
                    <div className={`bg-blr-image ${value.image}`}></div>
                  </div>
                  <div className="content">
                    <div className="inner">
                      {value.category === "UI/UX Design" ? (
                        <p>
                          UI
                          <span style={{ fontFamily: "QuickSand" }}>
                            <b>/</b>
                          </span>
                          UX Design
                        </p>
                      ) : (
                        <p>{value.category}</p>
                      )}

                      <h4>
                        <a href="/portfolio-details">{value.title}</a>
                      </h4>
                      <div className="portfolio-button">
                        <a
                          className="rn-btn"
                          href={value.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Live Work
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Portfolio;
